import axios, { InternalAxiosRequestConfig } from 'axios'

import { ENV } from '../../Environment'
import { GlobalContextInterface } from '../../Types/core'
import { API_ROUTES } from '../../constants/apiRoutes'
import { generateTraceparent } from '../../utils/generateTraceparent'
import { getCookie } from '../../utils/getCookies'

const globalContext: GlobalContextInterface = JSON.parse(
  sessionStorage.getItem('globalContext') ?? 'null',
)

const headers = {
  'aip-subscriptionKey': ENV().SubscriptionKey,
  'aip-brand': ENV().Brand,
  'aip-channel': ENV().Channel,
  'aip-company': ENV().Company,
  'aip-country': ENV().Country,
  'aip-language': ENV().Language,
  'aip-currency': ENV().Currency,
  'Content-Type': 'application/json',
  'Access-Control-Allow-Credentials': true,
}

export const api = axios.create({ baseURL: API_ROUTES.baseUrl, headers })

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const username = getCookie('pts_username')
  const authCookies = getCookie('auth')
  config.headers['aip-user'] = username || globalContext?.username || ''
  config.headers.Authorization = authCookies
  config.headers.traceparent = generateTraceparent()
  return config
})
